import { Link } from "react-router-dom";
import styled from "styled-components";

const NavigationButtonDiv = styled.div`
    display: block;
    text-align: right;
    width: 2.5rem;
    transition: font-size 0.1s ease-in-out 0s;
    &:hover {
        font-size: 2.2rem;
        cursor: pointer;
    }
`

export default function NavigationButton(props: { children: string, to: string }) {
    return (
        <Link to={props.to}><NavigationButtonDiv>{props.children}</NavigationButtonDiv></Link>
    );
}